module.exports = __webpack_public_path__ + "static/media/icon_defis_realises.52dd68e6.svg";